module.exports = __webpack_public_path__ + "static/media/mobile834.f369114d.png";